import type { StoreApi } from "zustand";
import type { TChatStore } from "../chat-store.types";
import type { TMessageStatus } from "./message.types";
import { messageStatusInitialState } from "./message.initial-state";

type TSetState = StoreApi<TChatStore>["setState"];

export const createMessageStatusActions = (set: TSetState) => ({
  setMessageStatusLoading: () =>
    set(() => ({
      messageStatus: { ...messageStatusInitialState, loading: true },
    })),

  setMessageStatusFulfilled: (source: TMessageStatus[]) =>
    set(() => ({
      messageStatus: { ...messageStatusInitialState, fetched: true, source },
    })),

  setMessageStatusRejected: (source: TMessageStatus[]) =>
    set(() => ({
      messageStatus: { ...messageStatusInitialState, error: true, source },
    })),

  resetMessageStatus: () =>
    set(() => ({ messageStatus: messageStatusInitialState })),
});
